export const SIDEBAR_PROVIDER_ID = 'SIDEBAR_PROVIDER';
